export enum ANIMATION_SIZE {
  MOBILE,
  DESKTOP,
  THUMBNAIL,
}

export enum EDITING_TEXT {
  IDLE,
  RECIPIENT,
  SENDER,
  TITLE,
  NOTE,
  SIGN_OFF,
  SIGNATURE,
  SLIDE_TEXT,
}
